<div *ngIf="isLoading$ | async" class="text-center">
  <div
    class="spinner-border"
    role="status"
    attr.aria-label="{{ 'wcag.loading' | translate }}"
  >
  </div>
</div>

<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [patchForm]="team$ | async"
  #formRef="ngForm"
  [hidden]="isLoading$ | async"
>
  <div class="pb-3 mb-4">
    <!-- Form Group -->
    <div class="mb-4">
      <label id="competitionId" class="form-label">
        {{ 'competitionModule.competition' | translate }}
        <small>({{ 'general.required' | translate | lowercase }})</small>
      </label>

      <input
        aria-labelledby="competitionId"
        *ngIf="teamId$ | async"
        class="form-control"
        type="text"
        inputmode="text"
        [value]="
          (competitionEntities$ | async)[form.value.competitionId]?.description
        "
        readOnly
      />

      <select
        aria-labelledby="competitionId"
        *ngIf="!(teamId$ | async)"
        formControlName="competitionId"
        [attr.aria-invalid]="
          form.controls.competitionId.dirty &&
          form.controls.competitionId.invalid
            ? 'true'
            : null
        "
        aria-describedby="competition"
        class="form-select"
      >
        <option *ngIf="!(teamId$ | async)" [ngValue]="null" selected>
          {{ 'general.select' | translate }}
        </option>
        <option
          *ngFor="let competition of competitions$ | async"
          [value]="competition.id"
        >
          {{ competition.description }}
        </option>
      </select>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="competition"
        role="alert"
        *ngIf="
          form.controls.competitionId.dirty &&
          form.controls.competitionId.invalid
        "
      >
        {{ 'competitionModule.competition' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      *ngIf="selectedCompetitionSummary"
      class="p-1 small mb-3 font-italic"
      [innerHTML]="selectedCompetitionSummary | safeHtml"
    ></div>

    <div class="mb-4" [hidden]="!form.value.competitionId">
      <label id="competitionLevelId" class="form-label">
        {{ 'competitionModule.preferredLevel' | translate }}
        <small>({{ 'general.required' | translate | lowercase }})</small>
      </label>

      <select
        aria-labelledby="competitionLevelId"
        aria-describedby="competitionLevel"
        formControlName="competitionLevelId"
        [attr.aria-invalid]="
          form.controls.competitionLevelId.dirty &&
          form.controls.competitionLevelId.invalid
            ? 'true'
            : null
        "
        class="form-select"
        required
      >
        <option *ngIf="!(teamId$ | async)" [ngValue]="null" selected>
          {{ 'general.select' | translate }}
        </option>
        <option
          *ngFor="let level of competitionLevels$ | async"
          [value]="level.id"
        >
          {{ level.description }}
        </option>
      </select>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="competitionLevel"
        role="alert"
        *ngIf="
          form.controls.competitionLevelId.dirty &&
          form.controls.competitionLevelId.invalid
        "
      >
        {{ 'competitionModule.preferredLevel' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4">
      <label id="descriptionId" class="form-label">
        {{ 'competitionModule.teamName' | translate }}
        <small>({{ 'general.required' | translate | lowercase }})</small>
      </label>

      <input
        aria-labelledby="descriptionId"
        aria-describedby="description description2"
        class="form-control"
        type="text"
        inputmode="text"
        maxlength="32"
        formControlName="description"
        required
        [attr.aria-invalid]="
          form.controls.description.dirty && form.controls.description.invalid
            ? 'true'
            : null
        "
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="description"
        role="alert"
        *ngIf="
          form.controls.description.dirty &&
          form.controls.description.invalid &&
          form.controls.description.errors &&
          !form.controls.description.errors.maxlength
        "
      >
        {{ 'general.description' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="description2"
        role="alert"
        *ngIf="
          form.controls.description.dirty &&
          form.controls.description.errors &&
          form.controls.description.errors.maxlength
        "
      >
        {{ 'general.description' | translate }}
        {{ 'general.isTooLong' | translate }}
      </p>
    </div>

    <div class="mb-4">
      <label id="shirtColourId" class="form-label">
        {{ 'competitionModule.shirtColour' | translate }}
        <small>({{ 'general.required' | translate | lowercase }})</small>
      </label>

      <div class="col-12 col-md-3 col-lg-2">
        <input
          aria-labelledby="shirtColourId"
          aria-describedby="shirtColour"
          class="form-control"
          type="color"
          maxlength="255"
          formControlName="shirtColour"
          required
          [attr.aria-invalid]="
            form.controls.shirtColour.dirty && form.controls.shirtColour.invalid
              ? 'true'
              : null
          "
        />
      </div>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="shirtColour"
        role="alert"
        *ngIf="
          form.controls.shirtColour.dirty && form.controls.shirtColour.invalid
        "
      >
        {{ 'competitionModule.shirtColour' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>
  </div>

  <div *ngIf="showSubmitButton" class="d-flex justify-content-end">
    <button class="btn btn-primary" type="submit" [disabled]="!form.dirty">
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
